class Environment {
    constructor(parent = null) {
        this.values = {};
        this.parent = parent;
    }

    define(name, value) {
        this.values[name] = value;
    }

    assign(name, value) {
        if (Object.prototype.hasOwnProperty.call(this.values, name)) {
            this.values[name] = value;
            return;
        }

        if (this.parent) {
            this.parent.assign(name, value);
            return;
        }

        throw new Error(`Undefined variable '${name}'.`);
    }

    get(name) {
        if (Object.prototype.hasOwnProperty.call(this.values, name)) {
            return this.values[name];
        }

        if (this.parent) {
            return this.parent.get(name);
        }

        throw new Error(`Undefined variable '${name}'.`);
    }
}

module.exports = Environment;
